import { useState } from "react";

export function useMultiModal<K extends string>(keys: K[]) {
  type ModalState = Record<K, boolean>;
  const initial = keys.reduce(
    (acc, key) => ({ ...acc, [key]: false }),
    {} as ModalState
  );
  const [modals, setModals] = useState<ModalState>(initial);

  const toggleModal = (key: K, value: boolean) => {
    setModals((prev) => ({ ...prev, [key]: value }));
  };

  return { modals, toggleModal };
}
